import { createContext } from "react";
import { contextFunctionInit } from "sprint-common-web";

import { ManzanitaPresetListingItem } from "../ManzanitaPresetListingItem";

interface IManzanitaPresetListingContext {
    items: ManzanitaPresetListingItem[];
    isLoading: boolean;
    addItem(item: ManzanitaPresetListingItem): void;
    editItem(item: ManzanitaPresetListingItem): void;
}

export const ManzanitaPresetListingContext = createContext<IManzanitaPresetListingContext>({
    items: [],
    isLoading: false,
    addItem: contextFunctionInit,
    editItem: contextFunctionInit
});
